module.exports = __webpack_public_path__ + "img/mover-arriba.65e9b39b.png";